import React from 'react';

export const ToggleSwitch = ({ 
  label, 
  checked, 
  onChange, 
  disabled = false, 
  name,
  className = "" 
}) => {
  return (
    <div className={`text-center ${className}`}>
      <div className="text-xs text-gray-500 mb-2">{label}</div>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          name={name}
          className="sr-only peer"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <div className={`w-11 h-6 bg-gray-500 rounded-full peer peer-checked:bg-blue-600 transition-colors ${disabled ? 'opacity-50' : ''}`}></div>
        <div className="absolute left-0.5 top-0.5 bg-white w-5 h-5 rounded-full transition-transform peer-checked:translate-x-full"></div>
      </label>
    </div>
  );
};